export const sendMessage = (message) => ({
    type: 'SEND_MESSAGE',
    message,
});
